import React from 'react';
import { Link } from '../Link';
import { CORE_LOGO_TEXT } from '../../constants/corePublicTheme';

export interface LogoProps {
  clearSearch?: (event?: React.MouseEvent<HTMLAnchorElement>) => Promise<void>;
  variant?: 'horizontal' | 'compact' | 'icon';
  className?: string;
  /** Pass when rendering outside Vike (e.g. SRP island) so Link can build correct hrefs */
  locale?: string;
}

/**
 * Logo component for navigation
 * horizontal: full logo + text, xl+ only
 * compact: logo + text, below xl
 * icon: icon-only small logo for scroll row / small screens
 */
export const Logo: React.FC<LogoProps> = ({
  clearSearch,
  variant = 'horizontal',
  className = '',
  locale,
}) => {
  if (variant === 'icon') {
    return (
      <Link
        href="/jobs"
        onClick={clearSearch}
        locale={locale}
        className={`inline-flex items-center justify-center flex-shrink-0 cursor-pointer rounded-lg lg:hidden ${className}`}
      >
        <img
          src="/logo.svg"
          height="32"
          width="32"
          alt="JobCrawls home"
          loading="lazy"
          className="object-contain h-8 w-8"
        />
      </Link>
    );
  }

  if (variant === 'compact') {
    return (
      <Link
        href="/jobs"
        onClick={clearSearch}
        locale={locale}
        className={`inline-flex items-center xl:hidden gap-2 cursor-pointer h-9 w-auto rounded-xl ${className}`}
      >
        <img
          src="/logo.svg"
          height="36"
          width="36"
          alt="JobCrawls home"
          loading="lazy"
          className="object-contain h-9 w-9"
        />
        <span className={`text-lg ${CORE_LOGO_TEXT}`}>JobCrawls</span>
      </Link>
    );
  }

  return (
    <Link
      href="/jobs"
      onClick={clearSearch}
      locale={locale}
      className={`hidden xl:inline-flex xl:items-center gap-2 cursor-pointer h-10 w-auto rounded-xl ${className}`}
    >
      <img
        src="/logo.svg"
        height="40"
        width="40"
        alt="JobCrawls home"
        loading="lazy"
        className="object-contain h-10 w-10"
      />
      <span className={`text-xl ${CORE_LOGO_TEXT}`}>JobCrawls</span>
    </Link>
  );
};
